var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('WebAuthnView',{attrs:{"isLoading":_vm.isLoading,"submit":_vm.submitPasswordReset}})
}
var staticRenderFns = []

export { render, staticRenderFns }